import React, { useEffect, useState } from 'react';
import Card from '../layout/Card';
import { Bell, Download } from 'lucide-react';
import { subscribeToPush } from '../utils/push';

const WidgetPwaNotif = () => {
    const [deferred, setDeferred] = useState(null)
    const [installed, setInstalled] = useState(window.matchMedia?.('(display-mode: standalone)').matches)
    const [notifState, setNotifState] = useState(typeof Notification !== 'undefined' ? Notification.permission : 'unsupported')
    const [busy, setBusy] = useState(false)
    const [msg, setMsg] = useState("")

    useEffect(() => {
        const onPrompt = (e) => { e.preventDefault(); setDeferred(e) }
        const onInstalled = () => setInstalled(true)
        window.addEventListener('beforeinstallprompt', onPrompt)
        window.addEventListener('appinstalled', onInstalled)
        return () => {
            window.removeEventListener('beforeinstallprompt', onPrompt)
            window.removeEventListener('appinstalled', onInstalled)
        }
    }, [])

    const install = async () => {
        if (!deferred) return
        deferred.prompt()
        const { outcome } = await deferred.userChoice
        if (outcome === 'accepted') setInstalled(true)
        setDeferred(null)
    }

    const enableNotif = async () => {
        setBusy(true); setMsg("")
        try {
            await subscribeToPush()
            setNotifState('granted')
            setMsg("Notifications activées ✓")
        } catch (e) {
            setMsg(e.message || "Erreur")
        }
        setBusy(false)
    }

    return (
        <Card>
            <p className='fb cw fs1 mb2'>Application &amp; notifications</p>
            <div className='df fdc gap1'>
                <button onClick={install} disabled={!deferred || installed} className='btn cw df aic jcc gap1'>
                    <Download size={18} color='#fff' /> {installed ? "Application installée" : "Installer l'application"}
                </button>
                <button onClick={enableNotif} disabled={busy || notifState === 'granted'} className='btn cs df aic jcc gap1'>
                    <Bell size={18} color='#fff' /> {notifState === 'granted' ? "Notifications activées" : "Activer les notifications"}
                </button>
                {msg && <p className='fr cw fs12' style={{ opacity: 0.7 }}>{msg}</p>}
                {!deferred && !installed && (
                    <p className='fr cw fs12' style={{ opacity: 0.5 }}>Sur iPhone : Partager → « Sur l'écran d'accueil »</p>
                )}
            </div>
        </Card>
    );
};

export default WidgetPwaNotif;
